import { isMentorScheduleEnabled } from "@/lib/posthog-events";

const NEW_BACKEND_PATHS = ["/v1/care", "/v1/reviews", "/v2/users/me"];

const matchesPath = (url: string, path: string) =>
  url === path || url.startsWith(`${path}/`);

const publishedStoryPath = /^\/v2\/users\/[^/]+\/story$/;
const schedulePath = /^\/v2\/users\/(?:[^/]+\/)?schedule(?:\/|$)/;

export const isNewBackendPath = (url: string) =>
  publishedStoryPath.test(url) ||
  (schedulePath.test(url) && isMentorScheduleEnabled()) ||
  NEW_BACKEND_PATHS.some((path) => matchesPath(url, path));

export const usesNewBackend = (url: string | undefined, method?: string) => {
  if (typeof url !== "string") return false;
  if (isNewBackendPath(url)) return true;
  return url === "/v2/users" && (method ?? "get").toLowerCase() === "get";
};
